import { Dialog, DialogProps } from "../../core/components/dialog.js";
import { Config } from "../../core/config/config.js";
import { Helper } from "../../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager.js";
import { NotificationHelper } from "../../core/util/notificationHelper.js";
import { ResourcePlanningSchedulerEventViewModel } from "../resourcePlanningScheduler.js";
import React from "react";
import ReactDOM from "react-dom";

export const OpenEventMovingDialog = (event: ResourcePlanningSchedulerEventViewModel, additionalInfo: AdditionalEventMovingInfo, title: string) => {
    return new Promise<boolean>(async (resolve) => {
        const result = await EventMovingDialogHelper.needShowDialog(event, additionalInfo);
        if (result.checkSkillsState == null && result.result) {
            resolve(true)
        } else {
            const targetElement = $("<div>");
            $("body").append(targetElement);
            const root = ReactDOM["createRoot"](targetElement[0]);
            const removeDialog = () => {
                (root as any).unmount(targetElement[0]);
                targetElement[0].remove();
            }

            const props: EventMovingDialogProps = {
                onOk: () => {
                    resolve(true);
                    removeDialog();
                },
                onCancel: () => {
                    resolve(false);
                    removeDialog();
                },
                event: event,
                additionalInfo: additionalInfo,
                title: title,
                checkSkillsState: result.checkSkillsState
            }
            root.render(<EventMovingDialog {...props} />);
        }
    });
}
class EventMovingDialogHelper {
    private static ignoreSkills = (event: ResourcePlanningSchedulerEventViewModel, additionalInfo: AdditionalEventMovingInfo) => {
        return !additionalInfo.checkSkills || !this.resourceChanged(event, additionalInfo) || !this.isResource(additionalInfo);
    }

    private static isResource = (additionalInfo: AdditionalEventMovingInfo) => {
        return additionalInfo.targetRessNr.indexOf("r|") !== -1;
    }

    private static resourceChanged = (event: ResourcePlanningSchedulerEventViewModel, additionalInfo: AdditionalEventMovingInfo) => {
        return event.ResourceId !== additionalInfo.targetRessNr;
    }

    private static showInMobileFieldServiceWarning = (event: ResourcePlanningSchedulerEventViewModel, additionalInfo: AdditionalEventMovingInfo) => {
        return this.resourceChanged(event, additionalInfo) &&
            Helper.hasValue(event.Datenpaket)
            && (Config.settings.movingAssignmentInMobileClientAction == 1
                || (Config.settings.movingAssignmentInMobileClientAction == 2
                    && Config.settings.excludedKnrsForForbiddenMobileClientAction.includes(event.KNr)));
    }

    private static showInMobileAppWarning = (event: ResourcePlanningSchedulerEventViewModel, additionalInfo: AdditionalEventMovingInfo) => {
        return this.resourceChanged(event, additionalInfo) &&
            event.IsSendToMobileApp
            && (Config.settings.movingAssignmentInMobileClientAction == 1
                || (Config.settings.movingAssignmentInMobileClientAction == 2
                    && Config.settings.excludedKnrsForForbiddenMobileClientAction.includes(event.KNr)));
    }

    public static getInMobileFieldServiceWarning = (event: ResourcePlanningSchedulerEventViewModel, additionalInfo: AdditionalEventMovingInfo) => {
        let showWarning = this.showInMobileFieldServiceWarning(event, additionalInfo);
        if (showWarning)
            return <div>{Helper.getTranslation("Einsatz.AlreadySendMobFieldService")}</div>;
        else
            return null
    }

    public static getInMobileAppWarning = (event: ResourcePlanningSchedulerEventViewModel, additionalInfo: AdditionalEventMovingInfo) => {
        let showWarning = this.showInMobileAppWarning(event, additionalInfo);
        if (showWarning)
            return <div>{Helper.getTranslation("Einsatz.AlreadySendMobApp")}</div>
        else
            return null
    }

    public static getSkillWarning = (event: ResourcePlanningSchedulerEventViewModel, additionalInfo: AdditionalEventMovingInfo, checkSkillsState: CheckSkillsState) => {
        let showWarning = !this.ignoreSkills(event, additionalInfo) && checkSkillsState.showDialogForSkills;
        if (showWarning)
            return <div style={{ marginTop: "5px" }} dangerouslySetInnerHTML={{ __html: checkSkillsState.skillWarningMessage }} />;
        else
            return null;
    }

    private static checkSkills = async (additionalInfo: AdditionalEventMovingInfo): Promise<CheckSkillsState> => {
        let arrResourceId = additionalInfo.targetRessNr.split("|");
        let result = await HTTPService.get<JsonResultClass>("Skills/CheckSkills?projNr=" + encodeURIComponent(additionalInfo.projNr)
            + "&pIndex=" + additionalInfo.pIndex
            + "&targetRessNr=" + encodeURIComponent(arrResourceId[1]));
        
        if (result.Code == 1) {
            NotificationHelper.showErrorMessage(result.Message);
            return null;
        }
        else {
            return {
                skillsChecked: true,
                showDialogForSkills: result.Code == 2,
                skillWarningMessage: Helper.getTranslation("WebSMS.ResourcePlanning.CheckSkillsMsg") + result.Message
            }
        }
    }
    
    public static needShowDialog = async (event: ResourcePlanningSchedulerEventViewModel, 
                                          additionalInfo: AdditionalEventMovingInfo) : Promise<{ checkSkillsState: CheckSkillsState, result: boolean}> => {
        let checkSkillsState: CheckSkillsState = {
            showDialogForSkills: false,
            skillsChecked: false,
            skillWarningMessage: null
        }
        
        if (!this.ignoreSkills(event, additionalInfo)) {
            checkSkillsState = await this.checkSkills(additionalInfo);
            if (checkSkillsState == null)
                return { checkSkillsState: null, result: false};
        }

        let showDialog = this.showInMobileFieldServiceWarning(event, additionalInfo)
            || this.showInMobileAppWarning(event, additionalInfo)
            || (!this.ignoreSkills(event, additionalInfo) && checkSkillsState.showDialogForSkills);

        if (!showDialog && (this.ignoreSkills(event, additionalInfo) || checkSkillsState.skillsChecked)) {
            return { checkSkillsState: null, result: true};
        }
        
        return { checkSkillsState: checkSkillsState, result: true};
    }
}


class EventMovingDialog extends React.Component<EventMovingDialogProps, null >{
    private _dialogProps: DialogProps = {
        title: this.props.title,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onOk();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.props.onCancel();
        },
        width: 500
    };

    constructor(props: EventMovingDialogProps) {
        super(props);
    }
    render() {
        return (<Dialog {...this._dialogProps} open={true} >
            <div style={{ display: "flex", flexDirection: "column" }} >
                {EventMovingDialogHelper.getInMobileFieldServiceWarning(this.props.event, this.props.additionalInfo)}
                {EventMovingDialogHelper.getInMobileAppWarning(this.props.event, this.props.additionalInfo)}
                {EventMovingDialogHelper.getSkillWarning(this.props.event, this.props.additionalInfo, this.props.checkSkillsState)}
            </div>
        </Dialog>)
    }
}

export interface CheckSkillsState {
    skillsChecked: boolean;
    showDialogForSkills: boolean;
    skillWarningMessage: string;
}
export interface AdditionalEventMovingInfo {
    checkSkills: boolean;
    projNr?: string;
    pIndex?: number;
    targetRessNr?: string;
}

export interface EventMovingDialogProps {
    event: ResourcePlanningSchedulerEventViewModel;
    title: string;
    onOk: () => void;
    onCancel: () => void;
    additionalInfo: AdditionalEventMovingInfo;
    checkSkillsState: CheckSkillsState;
}

